import React from 'react'
import { connect } from 'react-redux'

class OrderingDetail extends React.Component {
    state = {
        是否修改: false
    }

    componentDidMount = () => {
        const { id } = this.props
        Tyan.doPostEvent({
            event: 'GetOrdering',
            data: {
                id,
            },
            onEnd: ({ errorMessage, initValues基本信息, 是否修改, optionsParas }) => {
                if (errorMessage) {
                    Tyan.pubForm.showError(errorMessage)
                    return
                }
                this.setState({ initValues基本信息, 是否修改, optionsParas })
            }
        })
    }

    handlerClose = () => {
        const { onClose } = this.props
        onClose && onClose()
    }

    handlerSave = () => {
        const { id, onClose, onSave } = this.props
        const { changedValues基本信息 } = this.state
        Tyan.doPostEvent('SaveOrdering', {
            data: {
                id, changedValues基本信息
            },
            onEnd: ({ errorMessage }) => {
                if (errorMessage) {
                    Tyan.pubForm.showError(errorMessage)
                } else {
                    onSave && onSave()
                    onClose && onClose()
                }
            }
        })
    }

    fieldset基本信息 = () => {
        const { 订餐人数, 不订餐人数 } = this.state.initValues基本信息
        return [
            { _date: '订餐日期', disabled: true, minWidth: '93%', },
            { _select: `订餐人员（${订餐人数}）`, name: '订餐人员', minWidth: '93%', multiSelect: true, editable: true, forceSelection: false, },
            { _text: `不订餐人员（${不订餐人数}）`, name: '不订餐人员', disabled: true, minWidth: '93%', maxRows: 4 }
        ]
    }

    render() {
        const { showMessage: Message, showBody: Body } = this.props
        const { errorMessage, initValues基本信息, 是否修改 } = this.state

        if (!initValues基本信息) return <Message text={'请稍等 ...'} />
        if (errorMessage) return <Message text={errorMessage} />
        return <Body data={this} maxWidth='700'
            controls={
                [
                    { _button: '保存', icon: 'save', handler: this.handlerSave, cdt: () => 是否修改 },
                    { _button: '关闭', icon: 'close', handler: this.handlerClose },
                ]}
            fieldsets={
                [
                    { title: '', name: '基本信息', _fieldset: this.fieldset基本信息(), },
                ]}
        />
    }
}

export default connect()(OrderingDetail)